export default __webpack_public_path__ + "static/chat-ad32657bd20f4ceb7b004f4b80114ef5.png";